import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class CustomAttributesEditing extends Plugin {
  init() {
    const editor = this.editor;
    const schema = editor.model.schema;

    schema.addAttributeCheck(context => {
      if (CustomAttributesEditing.customModelElements.find(el => context.endsWith(el)) > -1) {
        return true;
      }
    });

    editor.conversion.for('downcast').add(dispatcher => {
      dispatcher.on('attribute', (evt, data, conversionApi) => {
        // This code is written to prevent adding text formatting attributes for empty <p> tags
        if (
          data?.item?.name === 'paragraph' && 
          data.item.isEmpty && 
          textFormattingAttributes.includes(data?.attributeKey)
        ) {
          return;
        }
        
        if (!CustomAttributesEditing.customModelElements.includes(data.item.name)) {
          return;
        }

        const viewWriter = conversionApi.writer;
        const viewElement = conversionApi.mapper.toViewElement(data.item);

        if (data.attributeNewValue) {
          viewWriter.setAttribute(data.attributeKey, data.attributeNewValue, viewElement);
        } else {
          viewWriter.removeAttribute(data.attributeKey, viewElement);
        }
      });
    });
  }
}

CustomAttributesEditing.customModelElements = [
  'inlinespan',
  'aside',
  'section',
  'div',
  'header',
  'span',
  'linkspan',
  'heading1',
  'heading2',
  'heading3',
  'heading4',
  'heading5',
  'heading6',
  'citation',
  'numberedcitation',
  'img',
  'figure',
  'audio',
  'video',
  'source',
  'inlineimage',
  'inlineaudio',
  'paragraph',
  'figcaptionTag',
  'hidedataignoreattribute'
];

const textFormattingAttributes = [
  "selection:bold",
  "selection:italic",
  "selection:underline",
  "selection:strikethrough",
  "selection:subscript",
  "selection:superscript",
  "selection:smallcaps"
];
